module.exports = __webpack_public_path__ + "img/shiren.c118cd4d.png";